import { API_GRAPH_BASE } from '../../../../config/env';
import { httpConstants } from '../../../../constants';
import { httpService } from '../../../../utility/httpService';

// API service class
export class CommentAPIService {
  private baseURL = `${API_GRAPH_BASE}/comments`; // Adjust based on your backend URL

  async createThread(data: {
    solution_id: string;
    org_id?: string;
    process_status: string;
    sub_process_status?: string;
    selected_text: string;
    text: string;
  }): Promise<any> {
    return httpService(httpConstants.METHOD_TYPE.POST, `${this.baseURL}/create-thread`, data, {
      'Content-Type': 'application/json',
    });
  }

  async addComment(data: {
    thread_id: string;
    text: string;
    parent_comment_id?: string | null;
  }): Promise<any> {
    return httpService(httpConstants.METHOD_TYPE.POST, `${this.baseURL}/add-comment`, data, {
      'Content-Type': 'application/json',
    });
  }

  async editComment(data: { comment_id: string; text: string }): Promise<any> {
    return httpService(httpConstants.METHOD_TYPE.PUT, `${this.baseURL}/edit-comment`, data, {
      'Content-Type': 'application/json',
    });
  }

  async deleteComment(comment_id: string): Promise<any> {
    return httpService(
      httpConstants.METHOD_TYPE.DELETE,
      `${this.baseURL}/delete-comment`,
      { comment_id },
      { 'Content-Type': 'application/json' }
    );
  }

  async getThreads(
    solution_id: string,
    process_status: string,
    sub_process_status?: string
  ): Promise<any> {
    const params = new URLSearchParams({
      solution_id,
      process_status,
      ...(sub_process_status && { sub_process_status }),
    });
    return httpService(
      httpConstants.METHOD_TYPE.GET,
      `${this.baseURL}/get-threads-by-solution-id?${params.toString()}`,
      null,
      { 'Content-Type': 'application/json' }
    );
  }

  async deleteThread(thread_id: string): Promise<any> {
    return httpService(
      httpConstants.METHOD_TYPE.DELETE,
      `${this.baseURL}/delete-thread`,
      { thread_id },
      { 'Content-Type': 'application/json' }
    );
  }
}
